const map = {
	"./bg/messages.json": 54220,
	"./cs/messages.json": 60007,
	"./de-AT/messages.json": 49400,
	"./en/messages.json": 77212,
	"./hr/messages.json": 72103,
	"./hu/messages.json": 27176,
	"./ro/messages.json": 89284,
	"./ru/messages.json": 41190,
	"./sk/messages.json": 31231
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65876;